import { SVGProps, useId } from "react";

export default function PhoneBookIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 80, width = 80, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M65.6723 0H20.6626C15.4036 0.00223215 11.141 4.26488 11.1388 9.52381V13.6384H6.66257C5.61049 13.6384 4.75781 14.4911 4.75781 15.5432C4.75781 16.5945 5.61049 17.4479 6.66257 17.4479H11.1194V29.9427H6.66257C5.61049 29.9427 4.75781 30.7954 4.75781 31.8475C4.75781 32.8996 5.61049 33.7522 6.66257 33.7522H11.1194V46.2478H6.66257C5.61049 46.2478 4.75781 47.1004 4.75781 48.1525C4.75781 49.2046 5.61049 50.0573 6.66257 50.0573H11.1194V62.5521H6.66257C5.61049 62.5521 4.75781 63.4055 4.75781 64.4568C4.75781 65.5089 5.61049 66.3616 6.66257 66.3616H11.1194V70.4762C11.1217 75.7351 15.3843 79.9978 20.6432 80H65.6529C70.9118 79.9978 75.1752 75.7351 75.1767 70.4762V9.52381C75.1842 4.2686 70.9275 0.00372023 65.6723 0ZM71.3865 70.4762C71.3769 73.628 68.824 76.1815 65.6723 76.1905H20.6626C17.5108 76.1815 14.9572 73.628 14.9483 70.4762V66.3616H19.4051C20.4572 66.3616 21.3099 65.5089 21.3099 64.4568C21.3099 63.4055 20.4572 62.5521 19.4051 62.5521H14.9483V50.0573H19.4051C20.4572 50.0573 21.3099 49.2046 21.3099 48.1525C21.3099 47.1004 20.4572 46.2478 19.4051 46.2478H14.9483V33.7522H19.4051C20.4572 33.7522 21.3099 32.8996 21.3099 31.8475C21.3099 30.7954 20.4572 29.9427 19.4051 29.9427H14.9483V17.4479H19.4051C20.4572 17.4479 21.3099 16.5945 21.3099 15.5432C21.3099 14.4911 20.4572 13.6384 19.4051 13.6384H14.9483V9.52381C14.9572 6.37202 17.5108 3.81845 20.6626 3.80952H65.6723C68.824 3.81845 71.3769 6.37202 71.3865 9.52381V70.4762Z"
        fill={`url(#paint0_${id})`}
      />
      <path
        d="M43.16 39.4479C48.2619 39.4479 52.3981 35.3118 52.3981 30.2098C52.3981 25.1071 48.2619 20.9717 43.16 20.9717C38.0573 20.9717 33.9219 25.1071 33.9219 30.2098C33.9263 35.3095 38.0595 39.4427 43.16 39.4479ZM43.16 24.7619C46.1577 24.7619 48.5885 27.1927 48.5885 30.1905C48.5885 33.1882 46.1577 35.619 43.16 35.619C40.1615 35.619 37.7314 33.1882 37.7314 30.1905C37.7366 27.1949 40.1637 24.7671 43.16 24.7619Z"
        fill={`url(#paint1_${id})`}
      />
      <path
        d="M43.1574 42.5141C35.2333 42.5141 29.0234 48.933 29.0234 57.1428C29.0264 58.1934 29.8776 59.0446 30.9282 59.0476H55.3858C56.4364 59.0446 57.2876 58.1934 57.2906 57.1428C57.2906 48.933 51.0807 42.5141 43.1574 42.5141ZM32.9855 55.2381C33.8047 50.0379 37.8999 46.3237 43.1574 46.3237C48.4141 46.3237 52.5286 50.0379 53.3285 55.2381H32.9855Z"
        fill={`url(#paint2_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="39.9673"
          y1="0"
          x2="39.9673"
          y2="80"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="43.16"
          y1="20.9717"
          x2="43.16"
          y2="39.4479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="43.157"
          y1="42.5141"
          x2="43.157"
          y2="59.0476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
